import { BasicValidationService } from '../../../../../shared/services/BasicValidationService';
import { AppCalculatorModel } from '../models/AppCalculatorModel';
import { AppApiService } from './AppApiService';

export class AppValidationService extends BasicValidationService<IbanAppDefinition> {
	private readonly appApiService: AppApiService;
	constructor(app: { options: BasicAppOptions<IbanAppDefinition> }, forms: JQuery) {
		super(app, forms);
		this.appApiService = new AppApiService(this.options);
	}

	public addCustomMethods(): void {
		super.addCustomMethods();

		$.validator.addMethod('customiban', this.validatorCustomIban.bind(this));

		$.validator.addMethod('oneibanrequired', this.validatorOneIbanRequired.bind(this));
	}

	public getBECreditCardCheckErrorMessage(): string {
		return this.options.app.validationmessages.backend['code_9900002'];
	}

	public getInvalidCreditCardErrorMessage(): string {
		return this.options.app.validationmessages.backend['code_9900003'];
	}

	private validatorOneIbanRequired(): boolean {
		let result = false;
		$('[name="Bankdaten.Iban"]').each((index, elm) => {
			const val = $(elm).val() as string;
			if (val && val.length) {
				result = true;
				return false;
			}
			return undefined;
		});
		return result;
	}

	private validatorCustomIban(value: string, element: HTMLElement): boolean {
		if (value.length === 0) {
			return true;
		}
		if (element) {
			const valdata = $(element).attr(BasicValidationService.BACKEND_VALIDATION_ATTR);
			if (valdata && valdata.length) {
				return false;
			}
		}
		return true;
	}

	/**
	 * validate german iban
	 */
	public isGermanIban(x: string): boolean {
		if (!x.match(/(DE[A-Z0-9]*)|(de[A-Z0-9]*)|(De[A-Z0-9]*)|(dE[A-Z0-9]*)/)) {
			return false;
		}
		if (x.length > 27) {
			return false;
		}
		return true;
	}

	public validateIban(
		bankdatenModel: AppCalculatorModel,
		successCallback: () => void,
		errorCallback: (jqxhr: JQuery.jqXHR, textStatus: string, errorThrown: string, iban: string) => void,
		showErrors = false,
		field?: HTMLInputElement): void {

		let reqStatred = false;
		const validation = this.getValidationApi();
		const successFunc = (): void => {
			successCallback();
			if (field) {
				$(field).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, null);
				if (reqStatred) {
					validation.stopRequest(field, true);
					validation.element($(field));
					this.decorateElement(field);
				}
			}
		};
		if (!bankdatenModel) {
			bankdatenModel = new AppCalculatorModel();
			if (field) {
				bankdatenModel.Iban = field.value;
			}
		}
		if (!bankdatenModel.Iban) {
			successFunc();
			return;
		}
		if (field) {
			reqStatred = true;
			validation.startRequest(field);
		}
		this.appApiService.checkIban(bankdatenModel,
			successFunc,
			(jqxhr: JQueryXHR, textStatus: string, errorThrown: string) => {
				errorCallback(jqxhr, textStatus, errorThrown, bankdatenModel.Iban);
				let id = "110007";
				if (showErrors && jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
					const messages = (jqxhr.responseJSON as ApiResponse<any>).Messages;
					let msg = "", src = "Iban";
					for (const message of messages) {
						if (message.Id) {
							id = message.Id.toString();
							msg = message.Message;
							if (message.Source) {
								src = message.Source;
								break;
							}
						}
					}
					const opts: { [key: string]: any } = {};
					if (field) {
						if (reqStatred) {
							validation.stopRequest(field, false);
						}
					} else {
						opts[this.lookupServerFieldnames[src] || "Bankdaten.Iban"] = this.options.app.validationmessages.backend[`code_${id}`] || msg;
						this.showErrors(opts);
					}
				}
				if (field) {
					$(field).attr(BasicValidationService.BACKEND_VALIDATION_ATTR, id);
					if (showErrors) {
						validation.element($(field));
						this.decorateElement(field);
					}
				}
			});
	}

	private getValidationApi(): {
		element: (element: JQuery) => void,
		startRequest: (element: HTMLInputElement) => void,
		stopRequest: (element: HTMLInputElement, showErrors: boolean) => void
	} {
		return $(this.forms)[0].validation;
	}

	public setIbanServerValidation(success: boolean, elementIdentifier: string): void {
		let $dateElement = $(this.forms).find(`[data-validation="${elementIdentifier}"]`);

		if ($dateElement.length === 0) {
			$dateElement = this.$ctx.find(`#${elementIdentifier}`);
		}
		$dateElement.data(BasicValidationService.VALIDATION_FAILED_MARKER, !success);
		if (success) {
			$dateElement.parents(this.rowClass).removeClass('is-error').addClass('is-valid');
			$dateElement.removeClass('is-error').addClass('valid');
		}
	}
}
